export default __webpack_public_path__ + "static/media/superscript.d20a6563.svg";